var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBabyHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29373",
    "data-name": "Group 29373",
    transform: "translate(-8 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17",
    transform: "translate(26 186.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49996",
    "data-name": "Path 49996",
    d: "M322.869,326.528H320v-5.02a1.434,1.434,0,0,1,1.434-1.434h1.434Z",
    transform: "translate(-308.526 -306.442)",
    fill: "#23aae6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49997",
    "data-name": "Path 49997",
    d: "M323.227,465.508h-2.869a.359.359,0,0,1-.359-.359v-1.076h2.869a.717.717,0,0,1,.717.717v.359A.359.359,0,0,1,323.227,465.508Z",
    transform: "translate(-308.526 -443.987)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49998",
    "data-name": "Path 49998",
    d: "M149.02,320.074a3.586,3.586,0,0,0-3.586,3.586v1.434H144v2.151a.717.717,0,0,0,.717.717h2.151a2.869,2.869,0,0,0,2.869-2.869v-5.02Z",
    transform: "translate(-140.414 -306.442)",
    fill: "#23aae6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49999",
    "data-name": "Path 49999",
    d: "M64.359,427.182h.359a.717.717,0,0,0,.717-.717v-2.39H64.359a.359.359,0,0,0-.359.359v2.39A.359.359,0,0,0,64.359,427.182Z",
    transform: "translate(-64 -405.78)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50000",
    "data-name": "Path 50000",
    d: "M101.02,320.074a3.586,3.586,0,0,0-3.586,3.586v1.076H96v2.51a.717.717,0,0,0,.717.717h2.151a2.869,2.869,0,0,0,2.869-2.869h2.151v1.434h2.869v-1.734a3.586,3.586,0,0,0,2.151-3.287v-1.434Z",
    transform: "translate(-94.566 -306.442)",
    fill: "#5ad7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50001",
    "data-name": "Path 50001",
    d: "M275.227,465.508h-2.869a.359.359,0,0,1-.359-.359v-1.076h2.869a.717.717,0,0,1,.717.717v.359A.359.359,0,0,1,275.227,465.508Z",
    transform: "translate(-262.677 -443.987)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 1.434,
    cy: 1.434,
    rx: 1.434,
    ry: 1.434,
    transform: "translate(11.474 12.198)",
    fill: "#ffd205"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50002",
    "data-name": "Path 50002",
    d: "M197.737,64.074a5.737,5.737,0,0,0,0,11.474h2.151a3.586,3.586,0,0,0,3.586-3.586V69.811A5.737,5.737,0,0,0,197.737,64.074Z",
    transform: "translate(-186.263 -61.916)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50003",
    "data-name": "Path 50003",
    d: "M249.793,192.074v3.586a1.793,1.793,0,0,1,0-3.586Z",
    transform: "translate(-239.753 -184.179)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 0.538,
    cy: 0.538,
    rx: 0.538,
    ry: 0.538,
    transform: "translate(12.192 7.895)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 0.538,
    cy: 0.538,
    rx: 0.538,
    ry: 0.538,
    transform: "translate(15.06 7.895)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50004",
    "data-name": "Path 50004",
    d: "M323.108,225.867a.478.478,0,0,1-.478-.478v-1.315a.956.956,0,0,1,.956.956v.359A.478.478,0,0,1,323.108,225.867Zm-2.032-.717h-.717a.359.359,0,1,1,0-.717h.717a.359.359,0,0,1,0,.717Zm3.944-.359a.359.359,0,0,0,.359.359h.341q.018-.177.018-.358v-.359h-.359A.359.359,0,0,0,325.02,224.791Z",
    transform: "translate(-308.526 -214.744)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50005",
    "data-name": "Path 50005",
    d: "M348.591,20.176h-.412a.179.179,0,0,1,0-.359h.412a2.28,2.28,0,0,0,2.278-2.278,1.256,1.256,0,0,0-1.255-1.255.9.9,0,0,0-.9.9.538.538,0,0,0,.538.538.179.179,0,0,1,0,.359.9.9,0,0,1-.9-.9,1.256,1.256,0,0,1,1.255-1.255,1.615,1.615,0,0,1,1.614,1.614A2.639,2.639,0,0,1,348.591,20.176Z",
    transform: "translate(-335.271 -15.926)",
    fill: "#463c4b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyHighlighted);
export default __webpack_public_path__ + "static/media/BabyHighlighted.1a0d19643db86f64b25b6b302bcb223a.svg";
export { ForwardRef as ReactComponent };